import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface ProfileFieldProps {
    label: string;
    value: ReactNode;
    units?: string;
    valueClassName?: string;
    containerClassName?: string;
}

export default function ProfileField({
    label,
    value,
    units,
    valueClassName = 'text-right font-semibold',
    containerClassName = 'flex justify-between text-base',
}: ProfileFieldProps) {
    const { t } = useTranslation('traineeReports');

    return (
        <div className={containerClassName}>
            <dt className="text-muted-foreground">{label}</dt>
            <dd className={valueClassName}>
                {value}
                {value !== t('na') && units}
            </dd>
        </div>
    );
}
